import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, hashHistory } from 'react-router';
import App from './components/Main';

// Render the main component into the dom
ReactDOM.render(
    <Router history={hashHistory} >
        <Route path="/" component={App}>
        </Route>
    </Router>,
    document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js